"use client"

import { useLocale, useTranslations } from "next-intl"
import React, { RefObject } from "react"

import "../../index.scss"

import { CloseCircleFilled } from "@ant-design/icons"
import { getSiteUrl } from "@repo/shared"
import IconFont from "@repo/ui/iconfont"
import { Input } from "antd"

interface MobileSearchProps {
  isOpen: boolean
  onClose: () => void
  scrollContainerRef: RefObject<HTMLDivElement | null>
}

/**
 * 移动端搜索组件（客户端组件）
 */
export const MobileSearch: React.FC<MobileSearchProps> = ({ isOpen, onClose, scrollContainerRef }) => {
  const local = useLocale()
  const t = useTranslations("HeaderComp")

  if (!isOpen) return null

  return (
    <>
      <div className="mobileSearchPanel">
        <div className="container">
          <div className="mobileSearchInputWrapper">
            <Input
              className="mobileSearchInput"
              placeholder={t("inputPlaceholder")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const value = (e.target as HTMLInputElement).value
                  const encodedValue = encodeURIComponent(value.trim())
                  window.location.href = `${getSiteUrl("www")}/${local}/search?keyword=${encodedValue}`
                  onClose()
                }
              }}
              allowClear={{
                clearIcon: <CloseCircleFilled style={{ fontSize: 16, color: "#00000040" }} />,
              }}
              size="middle"
              prefix={<IconFont type="icon-sousuocu" style={{ color: "#6b7280", fontSize: 16 }} />}
            />
          </div>
        </div>
      </div>
      {/* 移动端搜索遮罩层 */}
      <div ref={scrollContainerRef} className="mobileSearchOverlay" />
    </>
  )
}
